import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { businessInfo } from '../data/mock';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Vehicle', href: '#vehicle' },
    { name: 'Suitable For', href: '#suitable-for' },
    { name: 'Requirements', href: '#requirements' },
    { name: 'Insurance', href: '#insurance-guidance' },
    { name: 'FAQs', href: '#faqs' },
    { name: 'Contact', href: '#contact' },
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-24 lg:h-32">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_wfp-transit-lease/artifacts/41nr5knc_F975D878-74D0-409C-8954-495598ACD4D9.jpeg" 
              alt="WFP Sussex Vans" 
              className="h-16 sm:h-20 lg:h-24 w-auto mix-blend-multiply"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.name}
                onClick={() => scrollToSection(link.href)}
                className="text-slate-600 hover:text-sky-600 font-medium transition-colors duration-200"
              >
                {link.name}
              </button>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center gap-4">
            <Button 
              onClick={() => scrollToSection('#enquiry')}
              className="bg-sky-600 hover:bg-sky-700 text-white px-6"
            >
              Enquire Online
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-slate-600 hover:text-sky-600"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-slate-200 py-4">
          <nav className="flex flex-col px-4 space-y-3">
            {navLinks.map((link) => (
              <button
                key={link.name}
                onClick={() => scrollToSection(link.href)}
                className="text-left text-slate-600 hover:text-sky-600 font-medium py-2 transition-colors"
              >
                {link.name}
              </button>
            ))}
            <Button 
              onClick={() => scrollToSection('#enquiry')}
              className="bg-sky-600 hover:bg-sky-700 text-white w-full mt-4"
            >
              Enquire
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
